// ConversationStats component - displays Henri conversation metrics
// Shows KPI cards for total conversations, conversions, and conversion rate


/**
 * 
 * NOTES SUMMARY - HENRI DASHBOARD METRICS
 * 
 * What It Does:
 *  - Displays 6 KPI metric cards for Henri chatbot analytics
 *  - Takes stats data as a prop and formats it into visual cards
 *  - Shows: Total Conversations, Conversions, Conversion Rate, This Week's conversations, Total Queries, Avg Queries per Session

 *Where It's Used:
 *  Imported in: HenriDashboard.jsx 
 * 
 */


import React from 'react';
import KPICard from '../dashboard/KPICard';
import { COLORS } from '../../utils/constants';

function ConversationStats({ stats }) {
  // If no stats provided, return null
  if (!stats) return null;
  
  return (
    <div className="kpi-grid">
      <KPICard
        title="Total Conversations"
        value={stats.totalConversations || 0}
        color={COLORS.primary}
        tooltip="Total number of unique chat sessions with the Henri chatbot. Each session represents one visitor interaction."
      />
      <KPICard
        title="Conversions"
        value={stats.conversions || 0}
        subtitle="Became Leads"
        color={COLORS.success}
        tooltip="Chat sessions that resulted in a contact form submission. Tracks how effectively the chatbot drives engagement."
      />
      <KPICard
        title="Conversion Rate"
        value={`${stats.conversionRate || 0}%`}
        color={COLORS.secondary}
        tooltip="Percentage of chat sessions that converted to form submissions. Calculated as: (Conversions / Total Conversations) x 100"
      />
      <KPICard
        title="This Week"
        value={stats.recentConversations || 0}
        subtitle="Conversations"
        color={COLORS.warning}
        tooltip="Number of new chat sessions in the past 7 days."
      />
      <KPICard
        title="Total Queries"
        value={stats.totalQueries || 0}
        color={COLORS.primary}
        tooltip="Total number of individual questions asked to Henri across all chat sessions."
      />
      <KPICard
        title="Avg Queries/Session"
        value={stats.avgQueriesPerSession || 0}
        color={COLORS.secondary}
        tooltip="Average number of questions asked per chat session. Higher numbers indicate more engaged conversations."
      />
    </div>
  );
}

export default ConversationStats;